import React from 'react';
import { motion } from 'framer-motion';
import PlungerLogo from '../PlungerLogo';

const Footer = () => {
  return (
    <footer className="bg-[#1a140e] border-t border-white/5 py-8 sm:py-12 px-4 sm:px-6">
      <div className="max-w-[1280px] mx-auto flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-6">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="flex items-center gap-2 text-white opacity-50"
        >
          <PlungerLogo className="w-5 h-5 sm:w-6 sm:h-6" />
          <div className="flex flex-col">
            <span className="font-bold text-base sm:text-lg font-heading leading-none">PlungerXcel</span>
            <span className="text-[10px] sm:text-xs font-light text-gray-400">A product of Qult Technologies</span>
          </div>
        </motion.div>

        {/* Copyright */}
        <div className="text-gray-500 text-xs sm:text-sm text-center order-3 md:order-2">
© 2018 Qult Technologies. All rights reserved.
        </div>

        {/* Social Links */}
        <div className="flex gap-4 sm:gap-6 order-2 md:order-3">
          <a
            href="https://www.linkedin.com/company/qult-technologies/"
            className="text-gray-500 hover:text-primary transition-colors"
            aria-label="LinkedIn"
            target="_blank"
            rel="noreferrer"
          >
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
            </svg>
          </a>
          <a
            href="https://qult.ai"
            className="text-gray-500 hover:text-primary transition-colors"
            aria-label="Qult Website"
            target="_blank"
            rel="noreferrer"
          >
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 16.057v-3.057h2.994c-.059 1.143-.212 2.24-.456 3.279-.823-.12-1.674-.188-2.538-.222zm1.957 2.162c-.499 1.33-1.159 2.497-1.957 3.456v-3.62c.666.028 1.319.081 1.957.164zm-1.957-7.219v-3.015c.868-.034 1.721-.103 2.548-.224.238 1.027.389 2.111.446 3.239h-2.994zm0-5.014v-3.661c.806.969 1.471 2.15 1.971 3.496-.642.084-1.3.137-1.971.165zm2.703-3.267c1.237.496 2.354 1.228 3.29 2.146-.642.234-1.311.442-2.019.607-.344-.992-.775-1.91-1.271-2.753zm-7.241 13.56c-.244-1.039-.398-2.136-.456-3.279h2.994v3.057c-.865.034-1.714.102-2.538.222zm2.538 1.776v3.62c-.798-.959-1.458-2.126-1.957-3.456.638-.083 1.291-.136 1.957-.164zm-2.994-7.055c.057-1.128.207-2.212.446-3.239.827.121 1.68.19 2.548.224v3.015h-2.994zm1.024-5.179c.5-1.346 1.165-2.527 1.97-3.496v3.661c-.671-.028-1.329-.081-1.97-.165zm-2.005-.35c-.708-.165-1.377-.373-2.018-.607.937-.918 2.053-1.65 3.29-2.146-.496.844-.927 1.762-1.272 2.753zm-.549 1.918c-.264 1.151-.434 2.36-.492 3.611h-3.933c.165-1.658.739-3.197 1.617-4.518.88.361 1.816.67 2.808.907zm.009 9.262c-.988.236-1.92.542-2.797.9-.89-1.328-1.471-2.879-1.637-4.551h3.934c.058 1.265.231 2.488.5 3.651zm.553 1.917c.342.976.768 1.881 1.257 2.712-1.223-.49-2.326-1.211-3.256-2.115.636-.229 1.299-.435 1.999-.597zm9.924 0c.7.163 1.362.367 1.999.597-.931.903-2.034 1.625-3.257 2.116.489-.832.915-1.737 1.258-2.713zm.553-1.917c.27-1.163.442-2.386.501-3.651h3.934c-.167 1.672-.748 3.223-1.638 4.551-.877-.358-1.81-.664-2.797-.9zm.501-5.651c-.058-1.251-.229-2.46-.492-3.611.992-.237 1.929-.546 2.809-.907.877 1.321 1.451 2.86 1.616 4.518h-3.933z"/>
            </svg>
          </a>
          <a
            href="https://wa.me/923134832766"
            className="text-gray-500 hover:text-primary transition-colors"
            aria-label="WhatsApp"
            target="_blank"
            rel="noreferrer"
          >
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 0C5.373 0 0 5.373 0 12c0 2.761.832 5.324 2.263 7.5L1 24l4.8-1.2C7.7 23.1 9.8 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
              <path d="M17.5 14.5c-.3-.15-1.7-.85-1.96-.95-.26-.1-.45-.15-.64.15-.18.3-.7 1.02-.86 1.23-.16.2-.32.22-.6.07-.28-.15-1.2-.45-2.28-1.45-1.02-.92-1.66-2-1.83-2.29-.17-.29-.02-.44.13-.6.14-.14.32-.34.5-.52.18-.18.23-.3.34-.5.1-.2.05-.36-.02-.5-.07-.14-.66-1.6-.94-2.22-.28-.62-.57-.54-.78-.55l-.58-.01c-.2 0-.52.07-.8.36-.28.29-1.04 1.03-1.04 2.5s1.06 2.86 1.21 3.06c.15.2 2.02 3.08 4.9 4.32 0 0 .72.31 1.02.39.34.1.66.07.95.04.29-.03.88-.35 1.01-.7.14-.35.14-.64.09-.7-.05-.06-.16-.1-.34-.16z" />
            </svg>
          </a>
          <a
            href="mailto:tal.alexander@qult.ai"
            className="text-gray-500 hover:text-primary transition-colors"
            aria-label="Email"
            rel="noreferrer"
          >
            <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
